// AUTH API.
export const API_ADMIN_AUTH = '/admin/authenticate'; // authentification des utilisateurs

// ADMIN API
export const API_ADMIN = '/admin/utilisateurs'; // authentification des utilisateurs
